import types from './ActionTypes';

// Interfaces
import { ICourse, IInstituteList, IDepartmentList } from 'store/StateInterfaces';

// Utils
import coursesListToMap from 'Utils/CoursesListToMap';
import instituteListToMap from 'Utils/InstituteListToMap';
import departmentListToMap from 'Utils/DepartmentListToMap';


export function loadCoursesListRequest(parameters = null, state = null, limit = 16, offset = 0) {
    return dispatch => {
        let coursesListUrl = '/courseware/api/all_courses/' + (parameters ? parameters : '');
        let coursesListUrlCostom = '/courseware/api/all_courses/?course_info__is_published=True&limit=' + limit;
        if (state) {
            /*
            courseInstitute: null,
            courseDepartment: null,
            searchparam: null
            */
            coursesListUrlCostom += '&institute__name=' + (state.courseInstitute ? state.courseInstitute : '') +
                '&department__name=' + (state.courseDepartment ? state.courseDepartment : '') +
                '&search=' + (state.searchParam ? state.searchParam : '');
        }
        coursesListUrlCostom += '&offset=' + offset;
        return fetch(coursesListUrlCostom)
            .then(response => response.json())
            .then(data => {
                let paginationInfo = {
                    totalCourses: data.count,
                    nextLink: data.next,
                    prevLink: data.previous
                }
                let coursesMap = coursesListToMap(data.results);
                dispatch(loadCoursesListSuccess(coursesMap));
                dispatch(loadPaginationInfoSuccess(paginationInfo))
            }).catch(error => {
                throw (error);
            });
    };
};

export function getAllInstitute() {
    return dispatch => {
        let getAllInstituteUrl = '/courseware/get_allinstitutes';
        return fetch(getAllInstituteUrl)
            .then(response => response.json())
            .then(institutes => {
                let instituteMap = instituteListToMap(institutes['institutes']);
                dispatch(loadInstituteListSuccess(instituteMap));
            })
            .catch(error => {
                throw (error);
            });
    };
}
export function getAllDepartment() {
    return dispatch => {
        let getAllDepartmentUrl = '/courseware/get_alldepartments';
        return fetch(getAllDepartmentUrl)
            .then(response => response.json())
            .then(departments => {
                let departmentsMap = departmentListToMap(departments['departments']);
                dispatch(loadDepartmentListSuccess(departmentsMap));
            })
            .catch(error => {
                throw (error);
            });
    };
}

export function loadCoursesListSuccess(publicCoursesMap: Map<number, ICourse>) {
    return { type: types.LOAD_PUBLIC_COURSES_LIST_SUCCESS, publicCoursesMap };
};

export function loadCoursesListFailure() {
    return { type: types.LOAD_PUBLIC_COURSES_LIST_FAILURE };
};

export function loadInstituteListSuccess(instituteList: Map<number, IInstituteList>) {
    return { type: types.LOAD_INSTITUTE_LIST_SUCCESS, instituteList };
};
export function loadDepartmentListSuccess(departmentList: Map<number, IDepartmentList>) {
    return { type: types.LOAD_DEPARTMENT_LIST_SUCCESS, departmentList };
};

export function loadPaginationInfoSuccess(paginationInfo: any) {
    return { type: types.LOAD_PAGINATION_INFO_SUCCESS, paginationInfo };
}